function cov_23a0p69cth() {
  var path = "/app/src/types/card-theme.ts";
  var hash = "88aed1a30046a2b12178137de0822796c4625921";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/card-theme.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 25
        },
        end: {
          line: 4,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "88aed1a30046a2b12178137de0822796c4625921"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23a0p69cth = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_23a0p69cth();
export var CardTheme = (cov_23a0p69cth().s[0]++, {
  default: 'default',
  black: 'black'
});